import { graphql, useStaticQuery } from 'gatsby';

export default function CRMMenuLinks() {
  const CRMMenu = useStaticQuery(graphql`
    query MyCrmQuery {
      allMenuLinkContentCrm {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return CRMMenu;
}
